/* eslint-disable prettier/prettier */
import React from "react";
import { useNavigate } from "react-router-dom";
import AddCircleIcon from "@mui/icons-material/AddCircleOutline";
import { CircularProgress, Button, Typography } from "@mui/material";
import Box from "src/components/shared/atoms/box";
import SearchField from "src/components/shared/atoms/SearchField";
// import VideoPreviewer from "src/components/shared/atoms/VideoPreviewer";
import useStyles from "../Styles";

interface Props {
  onSearchTextChange: (value: string) => void;
  loading: boolean;
  text: string;
  count: number;
}
const Header: React.FC<Props> = ({
  onSearchTextChange,
  loading,
  text,
  count,
}) => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  // for search bar
  const searchBarHandle = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearchTextChange(e.target.value);
  };

  const searchFieldProps = {
    value: text,
    onChange: searchBarHandle,
    placeholder: "Search text or shortcut",
    fieldClass: classes.fieldStyle,
    searchBoxClass: classes.searchBoxClass,
    showEndIcon: true,
    endIcon: text && loading && (
      <CircularProgress size={20} sx={{ marginRight: "10px" }} />
    ),
  };

  const handleAddResponse = () => {
    navigate(`/settings/canned-response?mode=add`);
  };

  return (
    <Box className={classes.stickyHeader}>
      <Box className={classes.headerTopRow}>
        <Box className={classes.box}>
          <Typography className={classes.boxText}>Canned Responses</Typography>
          <Box className={classes.countBadge}>{count}</Box>
          {/* <VideoPreviewer videoId="ELf2MlpUUNY" /> */}
        </Box>
        <Button
          id="user_dropdown"
          aria-controls={undefined}
          aria-haspopup="true"
          aria-expanded={undefined}
          disableElevation
          onClick={handleAddResponse}
          variant="contained"
          startIcon={<AddCircleIcon className={classes.labelAddIcon} />}
          className={classes.labelAddButton}
        >
          Add New Response
        </Button>
      </Box>
      <Box className={classes.headerContainer}>
        <SearchField {...searchFieldProps} />
      </Box>
    </Box>
  );
};

export default Header;
